// extracted by mini-css-extract-plugin
export default {"loder-div":"Loader_loder-div__PdKwP","loader":"Loader_loader__RABVT","animFw":"Loader_animFw__NPgxb","coli1":"Loader_coli1__OevJO","coli2":"Loader_coli2__M78R-"};